import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSourceConversionReport } from "../../services/sourceconversion.services";

export const fetchSourceConversionReport = createAsyncThunk(
  "sourceConversionReport/fetchReport",
  async (period, { rejectWithValue }) => {
    try {
      const data = await getSourceConversionReport(period);
      return data; // Return the entire response
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const sourceConversionReportSlice = createSlice({
  name: "sourceConversionReport",
  initialState: {
    data: [],
    list: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSourceConversionReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSourceConversionReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data; // Processed data (lead types and counts)
        state.list = action.payload.list; // Raw list of leads
      })
      .addCase(fetchSourceConversionReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default sourceConversionReportSlice.reducer;
